<ng-template #requiredStar let-control="control">
  <span *ngIf="(control?.validator | asFunction)({})?.required">*</span>
</ng-template>

<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
</ng-template>

<ng-template #kategorieHeader let-title="title">
  <fa-icon [icon]="chevronIcon" class="custom-chevron"></fa-icon>
  <div class="h-100 align-items-center">
    <h6 class="text-uppercase m-0">{{ title }}</h6>
  </div>
</ng-template>

<form #theForm [formGroup]="stammdatenForm">
  <div
    *ngIf="categoriesState !== LoadingState.Loaded"
    class="w-100 text-center my-5"
  >
    <fa-icon [icon]="loadingIcon" animation="spin-pulse" size="5x"></fa-icon>
    <br/>
    Die Ansicht wird geladen ...
  </div>

  <div *ngIf="myMembership?.institution" class="alert alert-info mt-2">
    <div class="d-flex">
      <fa-icon [icon]="infoIcon" class="me-2 mt-1"></fa-icon>
      <div>
        Sie sind der folgenden Institution zugeordnet:
        <br/>
        <strong>{{ myMembership.institution.name }}</strong>
        <br/>
        {{ myMembership.institution.anschrift.strasse }} {{ myMembership.institution.anschrift.hausnummer }},
        {{ myMembership.institution.anschrift.plz }} {{ myMembership.institution.anschrift.ort }}
        <ng-container *ngIf="myMembership.institution.anschrift.adresszeile2">
          <br/>
          {{ myMembership.institution.anschrift.adresszeile2 }}
        </ng-container>
      </div>
    </div>
  </div>

  <div ngbAccordion>
    <div *ngIf="visibleCategories['Basisdaten']" [collapsed]="isCollapsed('Basisdaten')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Basisdaten'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div *ngIf="!($any(extradata)|keyvalue).length" [@vis] class="col-12"><p>wird geladen
                ...</p></div>
              <div *ngIf="($any(extradata)|keyvalue).length" [@vis] class="col-12">
                <ng-container *ngIf="'Sanakey/Kundennummer'; let key;">
                  <div *ngIf="visibleKeys[key]" class="row">
                    <div class="form-group col-6 col-lg-4 col-xl-2 ">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>
                      <input [formControlName]="key" class="form-control text-right">
                    </div>
                  </div>
                </ng-container>
                <div class="row">
                  <ng-container *ngIf="'Sanakey/Anrede'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-2 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>
                      <div class="position-relative">
                        <select [formControlName]="key" class="form-select">
                          <option value=""></option>
                          <option value="Frau">Frau</option>
                          <option value="Herr">Herr</option>
                          <option value="Divers">Divers</option>
                        </select>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
                    <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                  </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Titel'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-2 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input
                          [formControlName]="key"
                          [ngbTypeahead]="titleAuswahlConfig.titleAuswahl"
                          class="form-control"
                          container="form"
                          type="text"
                        />
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Vorname'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>
                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
                    <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                  </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Nachname'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/LANR'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/BSNR'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Institutionskennzeichen'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/HAEVG-ID'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <div
                    *ngIf="visibleKeys['Sanakey/Fachgruppe'] || visibleKeys['Sanakey/Region'] || visibleKeys['Sanakey/Verbandsmitgliedschaften']"
                    class="row">
                    <ng-container *ngIf="'Sanakey/Fachgruppe'; let key">
                      <div *ngIf="visibleKeys[key]" class="col-12 col-lg-6 form-group">
                        <label>
                          <span>{{ extradata[key]?.display_field_name }}</span>
                          <ng-container
                            *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                          <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                   [title]="extradata[key]?.display_help"
                                   class="info-icon ms-1"></fa-icon>
                        </label>

                        <div class="position-relative">
                          <input [formControlName]="key" class="form-control" type="text"/>
                          <span [ngClass]="{visible:processingData[key]}"
                                class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                        </div>
                        <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                          <san-form-input-error [message]="$any(k.value)"
                                                [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="'Sanakey/Region'; let key">
                      <div *ngIf="visibleKeys[key]" class="col-12 col-lg-6 form-group">
                        <label>
                          <span>{{ extradata[key]?.display_field_name }}</span>
                          <ng-container
                            *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                          <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                   [title]="extradata[key]?.display_help"
                                   class="info-icon ms-1"></fa-icon>
                        </label>

                        <div class="position-relative">
                          <input [formControlName]="key" class="form-control" type="text"/>
                          <span [ngClass]="{visible:processingData[key]}"
                                class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                        </div>
                        <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                          <san-form-input-error [message]="$any(k.value)"
                                                [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="'Sanakey/Verbandsmitgliedschaften'; let key">
                      <div *ngIf="visibleKeys[key]" class="col-12">
                        <div class="row">
                          <label class="col-12 form-group">
                            <span>{{ extradata[key]?.display_field_name }}</span>
                            <ng-container
                              *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                            <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                     [title]="extradata[key]?.display_help"
                                     class="info-icon ms-1"></fa-icon>
                          </label>
                        </div>
                        <div class="position-relative row">
                          <ng-container
                            *ngFor="let vm of $any(stammdatenForm.controls[key])?.controls; index as i; count as c">
                            <div class="form-group col-5 col-sm-6 d-flex align-items-end">
                              <div class="form-group w-100">
                                <label class="">Verbandsname:</label>
                                <div class="position-relative">
                                  <input
                                    #vn
                                    (change)="addEmptyVerbandsRow(!vn.value)"
                                    (focus)="$any(vm.controls[0]).controlFocused$.next($any($event).target.name)"
                                    (keyup)="addEmptyVerbandsRow(!vn.value)"
                                    (selectItem)="addEmptyVerbandsRow(!vn.value)"
                                    [formControl]="vm.controls[0]"
                                    [inputFormatter]="formatter"
                                    [ngbTypeahead]="$any(vm.controls[0]).auswahl"
                                    [resultTemplate]="rt"
                                    autocomplete="off"
                                    class="form-control form-select"
                                    container="form"
                                    type="text"
                                  />
                                  <span [ngClass]="{visible:processingData[key]}"
                                        class="loading-icon">
                            <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                          </span>
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-5">
                              <div class="form-group">
                                <label><small>(Optional)</small>
                                  Mitgliedsnummer:</label>
                                <div class="position-relative">
                                  <input [formControl]="vm.controls[1]"
                                         autocomplete="number"
                                         class="form-control"
                                         type="text">
                                  <span [ngClass]="{visible:processingData[key]}"
                                        class="loading-icon">
                      <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                    </span>
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-2 col-sm-1 d-flex align-items-end justify-content-end">
                              <div class="form-group float-right">
                                <a (click)="deleteVerbandEintrag($event, i)"
                                   [class.disabled]="i === c - 1"
                                   class="btn btn-outline-warning">
                                  <fa-icon [icon]="deleteVerbandIcon"></fa-icon>
                                </a>
                              </div>
                            </div>
                            <div class="form-group col-12">
                              <hr>
                            </div>
                          </ng-container>
                        </div>
                        <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                          <san-form-input-error [message]="$any(k.value)"
                                                [visible]="stammdatenForm.controls[key].dirty && stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Kontaktdaten']" [collapsed]="isCollapsed('Kontaktdaten')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Kontaktdaten'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div *ngIf="!($any(extradata)|keyvalue).length" [@vis] class="col-12"><p>wird geladen
                ...</p></div>
              <div *ngIf="($any(extradata)|keyvalue).length" [@vis] class="col-12">
                <div class="row">
                  <ng-container *ngIf="'Sanakey/Standard E-Mail'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-lg-6 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Zusaetzliche Abrechnungs E-Mail'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-lg-6 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <san-additional-abrechnungs-email [formControlName]="key"></san-additional-abrechnungs-email>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Telefonnummer'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-6 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Mobilnummer'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-6 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Faxnummer'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-6 col-lg-6 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Praxisdaten']" [collapsed]="isCollapsed('Praxisdaten')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Praxisdaten'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div *ngIf="!($any(extradata)|keyvalue).length" [@vis] class="col-12"><p>wird geladen
                ...</p></div>
              <div *ngIf="($any(extradata)|keyvalue).length" [@vis] class="col-12">
                <div class="row">
                  <ng-container *ngIf="'Sanakey/Name der Institution'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-lg-8 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Strasse'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-md-8 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Hausnummer'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-md-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="row">
                  <ng-container *ngIf="'Sanakey/Postleitzahl'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-md-4 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="'Sanakey/Ort'; let key">
                    <div *ngIf="visibleKeys[key]" class="col-12 col-md-8 form-group">
                      <label>
                        <span>{{ extradata[key]?.display_field_name }}</span>
                        <ng-container
                          *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                        <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                                 [title]="extradata[key]?.display_help"
                                 class="info-icon ms-1"></fa-icon>
                      </label>

                      <div class="position-relative">
                        <input [formControlName]="key" class="form-control" type="text"/>
                        <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                      </div>
                      <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                        <san-form-input-error [message]="$any(k.value)"
                                              [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Bankdaten']" [collapsed]="isCollapsed('Bankdaten')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Bankdaten'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <san-bankdaten #bankdatenComponent
                         [forceRequired]="forceRequired"
                         [parentForm]="parentForm"
                         [supressRequired]="supressRequired">
          </san-bankdaten>
        </div>
      </div>
    </div>
    <div ngbAccordionItem *ngIf="showVerwalterAccounts && categoriesState === LoadingState.Loaded" [collapsed]="isCollapsed('VerwalterAccounts')" class="w-100">
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Verwalter-Accounts'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <san-verwalter-accounts></san-verwalter-accounts>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Krankenkasse']" [collapsed]="isCollapsed('Krankenkasse')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Krankenkasse'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <div *ngIf="!($any(krankenkassendata)|keyvalue).length" [@vis] class="col-12"><p>wird geladen
            ...</p></div>
          <div *ngIf="($any(krankenkassendata)|keyvalue).length" [@vis] class="col-12">
            <div class="row">
              <ng-container *ngIf="'Sanakey/Krankenkasse Ik'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-lg-4 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="'Sanakey/Krankenkasse Name'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-lg-4 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="'Sanakey/Krankenkasse Logo'; let key">
                <div *ngIf="visibleKeys[key] && krankenkassendata[key] !== null"
                     class="col-12 col-lg-4 form-group">
                  <div class="position-relative">
                    <img [ngSrc]="krankenkassendata[key]" alt="Kein Logo" height="100" width="100"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                </span>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="row">
              <ng-container *ngIf="'Sanakey/Krankenkasse Strasse'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-md-8 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="'Sanakey/Krankenkasse Hausnummer'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-md-4 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="row">
              <ng-container *ngIf="'Sanakey/Krankenkasse Postleitzahl'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-md-4 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="'Sanakey/Krankenkasse Ort'; let key">
                <div *ngIf="visibleKeys[key]" class="col-12 col-md-8 form-group">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>

                  <div class="position-relative">
                    <input [formControlName]="key" class="form-control" type="text"/>
                    <span [ngClass]="{visible:processingData[key]}" class="loading-icon">
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
            </span>
                  </div>
                  <div *ngFor="let k of $any(validatorMessages[key]) | keyvalue">
                    <san-form-input-error [message]="$any(k.value)"
                                          [visible]="stammdatenForm.controls[key].hasError($any(k.key))"></san-form-input-error>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Zertifizierungen und Nachweise']" [collapsed]="isCollapsed('Zertifizierungen und Nachweise')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container
            *ngTemplateOutlet="kategorieHeader; context:{title: 'Zertifizierungen und Nachweise'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <san-zertifizierungen #zertifizierungenComponent></san-zertifizierungen>
        </div>
      </div>
    </div>
    <div *ngIf="visibleCategories['Selbstauskünfte']" [collapsed]="isCollapsed('Selbstauskünfte')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container
            *ngTemplateOutlet="kategorieHeader; context:{title: 'Selbstauskünfte'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-container *ngIf="'Sanakey/Selbstauskunft/400xInjektionstechniken-24M'; let key">
            <div *ngIf="visibleKeys[key]" class="form-group">
              <div class="row">
                <div class="col-12 col-lg-5">
                  <label>
                    <span>{{ extradata[key]?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>
                  <div class="position-relative">
                <textarea class="form-control" disabled>
    Innerhalb der letzten 24 Monate habe ich 400 Eingriffe bzgl. der Injektionstechniken (Periradikuläre Therapie (PRT)/Facettensyndrom) durchgeführt.
                </textarea>
                  </div>
                </div>
                <div *ngIf="visibleKeys[key + '/Kommentar']" class="col-12 col-lg-5">
                  <label *ngIf="visibleKeys[key + '/Kommentar']">
                    <span>{{ extradata[key + '/Kommentar']?.display_field_name }}</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key + '/Kommentar']}"></ng-container>
                    <fa-icon *ngIf="extradata[key + '/Kommentar']?.display_help" [icon]="infoIcon"
                             [title]="extradata[key + '/Kommentar']?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>
                  <div *ngIf="visibleKeys[key + '/Kommentar']" class="position-relative">
                <textarea [formControlName]="key + '/Kommentar'"
                          [placeholder]="(extradata[key + '/Kommentar']?.required) ? '' : 'Optional'"
                          class="form-control"></textarea>
                    <span [ngClass]="{visible:processingData[key + '/Kommentar']}"
                          class="loading-icon">
                  <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon>
                </span>
                  </div>
                </div>
                <div class="col-12 col-lg-2">
                  <label>
                    <span>Bestätigung</span>
                    <ng-container
                      *ngTemplateOutlet="requiredStar; context:{control: stammdatenForm.controls[key]}"></ng-container>
                    <fa-icon *ngIf="extradata[key]?.display_help" [icon]="infoIcon"
                             [title]="extradata[key]?.display_help"
                             class="info-icon ms-1"></fa-icon>
                  </label>
                  <div class="position-relative">
                    <input [formControlName]="key" class="form-check" type="checkbox"/>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="speichernBtnVisible && categoriesState === LoadingState.Loaded && !isManagedAccount" [collapsed]="isCollapsed('Sicherheit')" class="w-100" ngbAccordionItem>
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <ng-container *ngTemplateOutlet="kategorieHeader; context:{title: 'Sicherheit'}"></ng-container>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <div class="row">
            <div [@vis] class="col-12">
              <div class="row">
                <div class="col-12 form-group">
                  <label>
                    <span>Passwort</span>
                    <fa-icon [icon]="infoIcon" class="info-icon ms-1"
                             title="Ihr Passwort zur Anmeldung auf der Plattform"></fa-icon>
                  </label>
                  <div class="position-relative">
                    <div [routerLink]="['passwort']" class="btn btn-primary">
                      Passwort ändern
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 form-group">
                  <label>
                    <span>Zwei-Faktor-Authentifizierung</span>
                    <fa-icon [icon]="infoIcon" class="info-icon ms-1"
                             title="Ihr zweiter Faktor zur Anmeldung auf der Plattform (E-Mail TAN, Authenticator TAN)"></fa-icon>
                  </label>
                  <div class="position-relative">
                    Aktive Geräte:
                    <ul>
                      <li *ngIf="authDevices.length === 0">
                        Es ist kein Gerät aktiv
                      </li>
                      <li *ngFor="let device of authDevices">
                        {{ device.name }}&nbsp;<span
                        *ngIf="device.id === authDeviceActive">(hier in Verwendung)&nbsp;</span>
                        <a (click)="deleteDevice(device)" href="javascript:void(0)">
                          Gerät deaktivieren und löschen
                        </a>
                      </li>
                    </ul>
                    <div [routerLink]="['2fa']" class="btn btn-primary">
                      <span *ngIf="authDevices.length">Weiteres</span> Gerät aktivieren
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr *ngIf="speichernBtnVisible && categoriesState === LoadingState.Loaded">
    <div *ngIf="speichernBtnVisible && categoriesState === LoadingState.Loaded" class="mt-3">
      <button (click)="speichern()"
              [disabled]="processingAnyData"
              class="btn btn-primary">Speichern<span *ngIf="processingAnyData">
      &nbsp;<fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon></span></button>
    </div>
  </div>
</form>
